module.exports = __webpack_public_path__ + "img/HEB.814f7418.png";